module.exports = __webpack_public_path__ + "img/heartsArrows-1.29bf6cb.webp";